import { Box, Button, Heading } from '@chakra-ui/react'
import { useContext } from 'react'

import { SendContractEmailButton } from '@/containers/SendContractEmailButton'
import { SendContractContextProvider, SendContractModal } from '@/containers/SendContractModal'

import { ContractAcceptationType } from 'BrokerTsLib/src/enums/ContractAcceptationType'
import { Container } from '../../../components/Container'
import {
  FormSection,
  FormSectionBody,
  FormSectionDescription,
  FormSectionHeader,
  FormSectionTitle,
} from '../../../components/FormSection'
import { Loading } from '../../../components/Loading'
import { MainContent } from '../../../components/MainContent'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { AddVehicleInfo } from '../../../containers/AddVehicleInfo'
import { ContractEmailHistory } from '../../../containers/carkulka/ContractEmailHistory'
import { ContractRecap } from '../../../containers/carkulka/ContractRecap'
import { InsuranceDownloads } from '../../../containers/carkulka/InsuranceDownloads'
import { Recap } from '../../../containers/carkulka/Recap'
import { RecapExtraInsuranceSingle } from '../../../containers/carkulka/RecapExtraInsuranceSingle'
import { FormButtons } from '../../../containers/FormButtons'
import { InsuranceSummary } from '../../../containers/InsuranceSummary'
import { MeetingRecordOverview } from '../../../containers/MeetingRecordOverview'
import { addonOffersContext } from '../../../context/OfferAddonContext'
import { StepsContent } from '../../../context/StepsContext'
import { baseUrl } from '../../../hooks'
import { useApp } from '../../../hooks/useApp'
import { useUrl as useInsuranceParamsUrl } from '../../../hooks/useInsuranceParams'
import { Duplicate } from '../../../icons'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'

export const CompletedPage = () => {
  const { app } = useApp()
  const url = useInsuranceParamsUrl()

  const { addonOffers } = useContext(addonOffersContext)
  const { insuranceParams, insuranceParamsId, isLoadingData } = useInsuranceParamsContext()

  const validAddonOffers = addonOffers?.filter((ao) => ao.valid)

  const cloneUrl = `${baseUrl}/${app}/wizard/1`

  return (
    <Section>
      {isLoadingData && <Loading sx={{ marginRight: 8, display: 'flex' }} />}
      {!isLoadingData && (
        <Container>
          <StepsContent step={5}>
            <Heading
              sx={{
                fontSize: '5xl',
                fontWeight: 'bold',
                letterSpacing: 'tighter',
                textAlign: 'center',
              }}
              as="h1"
            >
              Sjednané pojištění č. {insuranceParams?.generalParams.contractNumber}
            </Heading>

            <Steps icon="car" />

            <InsuranceSummary />

            <MainContent>
              <Recap />

              <SendContractContextProvider insuranceId={insuranceParams?.generalParams.insuranceId ?? undefined}>
                <SendContractModal />
                <FormSection>
                  <FormSectionHeader>
                    <FormSectionTitle>Dokumenty k pojištění</FormSectionTitle>

                    <FormSectionDescription>
                      <SendContractEmailButton />
                    </FormSectionDescription>
                  </FormSectionHeader>

                  <FormSectionBody>
                    {insuranceParams?.generalParams.selectedOfferId && (
                      <InsuranceDownloads paramsId={insuranceParams.generalParams.paramsId!} insurerOfferId={insuranceParams.generalParams.selectedOfferId} />
                    )}

                    {insuranceParams?.generalParams.paramsId && (
                        <ContractEmailHistory
                          paramsId={insuranceParams?.generalParams.paramsId}
                          insurerOfferId={insuranceParams.generalParams.selectedOfferId!}
                          isAutomaticallySent={(
                            insuranceParams.generalParams.contractAcceptationType === ContractAcceptationType.Payment ||
                            insuranceParams.generalParams.contractAcceptationType === ContractAcceptationType.DigitalSignature
                          )}
                        />
                      )}
                  </FormSectionBody>
                </FormSection>
              </SendContractContextProvider>

              {/* {false && <ExpiredContractCancellationForm onSubmit={() => { }} />} */}

              {validAddonOffers && validAddonOffers.length > 0 && (
                <Box
                  sx={{
                    bg: 'gray.100',
                    mb: 8,
                    p: 4,
                    borderRadius: 'md',
                    '& > *': {
                      mb: 4,
                    },
                    '& > *:last-of-type': {
                      mb: 0,
                    },
                  }}
                >
                  {validAddonOffers.map((x) => (
                    <RecapExtraInsuranceSingle key={x.offerId} offerAddon={x} />
                  ))}
                </Box>
              )}

              <ContractRecap />

              <MeetingRecordOverview />
            </MainContent>
          </StepsContent>

          <FormButtons
            leftButtons={
              <>
                <Button
                  variant="outline"
                  as="a"
                  href={`${url}/CloneUrl?paramsId=${insuranceParamsId}&replacement=${false}&returnUrl=${encodeURIComponent(cloneUrl)}`}
                >
                  <Duplicate color="secondary.500" />
                  Klonovat
                </Button>

                <AddVehicleInfo />
              </>
            }
          />
        </Container>
      )}
    </Section>
  )
}
